<template>
  <div class="slds-form-element" :class="{ 'slds-has-error': !valid }">
    <label class="slds-form-element__label" v-if="label">
      <abbr class="slds-required" title="required" v-if="required">*</abbr>
      {{ label }}
    </label>
    <div class="slds-form-element__control">
      <textarea
        class="slds-textarea"
        :disabled="disabled"
        :placeholder="placeholder"
        @input="handleInput"
        v-model="localValue"></textarea>
    </div>
    <div class="slds-text-align_right slds-text-body_small" v-if="maxLength">{{(localValue || '').length}} / {{maxLength}}</div>
    <div class="slds-form-element__help" v-if="!valid">{{error}}</div>
  </div>
</template>
<script>
export default {
  props: {
    disabled: Boolean,
    label: String,
    maxLength: [String, Number],
    placeholder: String,
    required: Boolean,
    value: String
  },
  created () {
    this.localValue = this.value
  },
  data () {
    return {
      error: '',
      localValue: ''
    }
  },
  computed: {
    valid () {
      return this.error === ''
    }
  },
  methods: {
    clearValidationError () {
      this.error = ''
    },
    handleInput () {
      this.clearValidationError()
      this.$emit('input', this.localValue)
    },
    validate () {
      let valid = true
      if (this.required && !this.localValue) {
        valid = false
        this.error = this.$t('validation.required')
      }

      if (valid && !!this.maxLength && !!this.localValue && this.localValue.length > this.maxLength) {
        valid = false
        this.error = this.$t('validation.maxLength', { maxValue: this.maxLength })
      }

      return valid
    }
  },
  watch: {
    disabled (value) {
      if (value) {
        this.localValue = ''
        this.handleInput()
      }
    },
    value (value) {
      this.localValue = value
    }
  }
}
</script>
<style lang="scss" scoped>
  .count {
    float: right;
    padding: 0.1rem 0 0 0;
    font-size: 0.875rem;
  }
</style>
